var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgTickRounded(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M22.775 10.066l-8.348 9.918-4.453-4.629a.873.873 0 00-1.267 0 .935.935 0 000 1.29l5.13 5.333c.14.145.321.237.516.264l.14.008a.885.885 0 00.652-.316l8.978-10.667a.935.935 0 00-.084-1.287.875.875 0 00-1.264.086z"
  }));
}

export default SvgTickRounded;